"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHOD_HTTP = void 0;
var METHOD_HTTP;
(function (METHOD_HTTP) {
    METHOD_HTTP["POST"] = "POST";
    METHOD_HTTP["GET"] = "GET";
    METHOD_HTTP["PUT"] = "PUT";
    METHOD_HTTP["DELETE"] = "DELETE";
    METHOD_HTTP["PATCH"] = "PATCH";
})(METHOD_HTTP = exports.METHOD_HTTP || (exports.METHOD_HTTP = {}));
